/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react"
import { CircularProgress, Tooltip } from "@material-ui/core"
import { format as dateFnsFormat } from "date-fns"
import { Doughnut } from "react-chartjs-2"
import { getRequest } from "utils/request"

import "./style.css"

import { translate } from "../../translate/i18n"
import AttendentDashboard from "./AttendentDashboard"
import { useNotification } from "hooks/notification"
import { useAuth } from "hooks/auth"
import { useModal } from "hooks/modal"
import format from "utils/dateFormat"
import { OnlineOfflineUserBadge } from "components/OnlineOfflineUserBadge"
import { ImageLoader } from "components/ImageLoader"
import { ShowOnlyOnlineUsersSelector } from "./components/ShowOnlyOnlineUsersSelector"

const colorsBarCompany = [
  {
    description: "Whatsapp",
    color: "#70AD47",
  },
  {
    description: "Facebook",
    color: "#5B9BD5",
  },
  {
    description: "Instagram",
    color: "#8134AF",
  },
  {
    description: "SKUTE",
    color: "#ff8533",
  },
  {
    description: "Chat",
    color: "#99ccff",
  },
  {
    description: "Whatsapp QRCODE",
    color: "#fff",
  },
]
const colorsBar = [
  "#681E99",
  "#6F2384",
  "#A753A9",
  "#AC8CC8",
  "#2DB2BC",
  "#70C5CB",
  "#C04949",
  "#F75858",
  "#5A6891",
  "#F0B700",
  "#F5CC63",
  "#FFF8CA",
]
const options2 = {
  responsive: true,
  legend: {
    display: true,
  },
  type: "pie",
  scales: {
    xAxes: [
      {
        display: false, //this will remove all the x-axis grid lines
      },
    ],
    yAxes: [
      {
        display: false, //this will remove all the x-axis grid lines
      },
    ],
  },
  plugins: {
    datalabels: {
      display: true,
      color: "black",
    },
  },
}

export default function Home() {
  const [data, setData] = useState([])
  const [dataChartByTicket, setDataChartBytTicket] = useState([])
  const [listUsers, setListUsers] = useState([])
  const [showOnlyOnlineUsers, setShowOnlyOnlineUsers] = useState(false)

  // eslint-disable-next-line no-unused-vars
  const [ticketOpenToday, setTicketOpenToday] = useState(0)
  const [waitingtime, setWaitingTime] = useState(0)
  const [maximumwaitingtime, setMaximumWaitingTime] = useState(0)
  const [averageservicetime, setAverageServiceTime] = useState(0)
  const [maximumservicetime, setMaximumServiceTime] = useState(0)
  const [ticketInProgress, setTicketInProgress] = useState(0)
  const [ticketNoAgent, setTicketNoAgent] = useState(0)
  const [update, setUpdate] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingChart, setLoadingChart] = useState(false)
  const [slaExpiredDated, setSLAExpiredDated] = useState(false)
  const [slaExpiredOpen, setSLAExpiredOpen] = useState(false)

  const { selectedCompany } = useNotification()
  const { user } = useAuth()
  const { toggleHelperId } = useModal()

  // const getUser = localStorage.getItem('user-omni');
  // const user = JSON.parse(getUser);

  const loadCompanyTickets = async () => {
    if (!selectedCompany.id) return

    const response = await getRequest(
      `/tickets/opentoday?CompanyId=${selectedCompany.id}`
    )
    if (response.success) {
      setTicketOpenToday(response.data.count)
    }
  }

  const loadSelectedCompany = async () => {
    if (!selectedCompany.id) return

    const response = await getRequest(
      `/tickets/inprogress?CompanyId=${selectedCompany.id}`
    )

    if (response.success) {
      setTicketInProgress(response.data.count)
    }
  }

  const loadWaitingTime = async () => {
    if (!selectedCompany.id) return

    const response = await getRequest(
      `/dashboards/waitingtime?CompanyId=${selectedCompany.id}`
    )
    if (response.success) {
      setWaitingTime(response.data.count)
    }
  }

  const loadMaximumWaitingTime = async () => {
    if (!selectedCompany.id) return

    const response = await getRequest(
      `/dashboards/maximumwaitingtime?CompanyId=${selectedCompany.id}`
    )

    if (response.success) {
      setMaximumWaitingTime(response.data.count)
    }
  }

  const loadAverageServiceTime = async () => {
    if (!selectedCompany.id) return

    const response = await getRequest(
      `/dashboards/averageservicetime?CompanyId=${selectedCompany.id}`
    )

    if (response.success) {
      setAverageServiceTime(response.data.count)
    }
  }

  const loadMaximumServiceTime = async () => {
    if (!selectedCompany.id) return

    const ReturnGet2 = await getRequest(
      `/dashboards/maximumservicetime?CompanyId=${selectedCompany.id}`
    )
    if (ReturnGet2.success) {
      setMaximumServiceTime(ReturnGet2.data.count)
    }
  }

  const loadTicketNoAgent = async () => {
    if (!selectedCompany.id) return

    const response = await getRequest(
      `/tickets/noagent?CompanyId=${selectedCompany.id}`
    )

    if (response.success) {
      setTicketNoAgent(response.data.count)
    }
  }

  const loadSLAExpiredDated = async () => {
    if (!selectedCompany.id) return

    const dateToday = dateFnsFormat(new Date(), "yyyy-MM-dd")
    const response = await getRequest(
      `/dashboards/slaexpireddated?&CompanyId=${selectedCompany.id}&beginDate=${dateToday}&endDate=${dateToday}`
    )
    if (response.success) {
      setSLAExpiredDated(response.data.quantity)
    }
  }

  const loadSLAExpiredOpen = async () => {
    if (!selectedCompany.id) return

    const dateToday = dateFnsFormat(new Date(), "yyyy-MM-dd")
    const response = await getRequest(
      `/dashboards/slaexpiredopen?&CompanyId=${selectedCompany.id}&beginDate=${dateToday}&endDate=${dateToday}`
    )
    if (response.success) {
      setSLAExpiredOpen(response.data.quantity)
    }
  }

  const loadChartByCompany = async () => {
    if (!selectedCompany.id) return

    // //BUSCA DADOS PARA MONTAR GRAFICO
    setLoadingChart(true)
    const dateToday = dateFnsFormat(new Date(), "yyyy-MM-dd")

    const ReturnGet = await getRequest(
      `/reports/getbychannel?&CompanyId=${selectedCompany.id}&beginDate=${dateToday}&endDate=${dateToday}`
    )

    if (ReturnGet.success) {
      ChartbyCompany(ReturnGet.data)
    }
    setLoadingChart(false)
  }

  const loadChartTicketByCompany = async () => {
    if (selectedCompany.id >= 0) {
      // //BUSCA DADOS PARA MONTAR GRAFICO
      setLoadingChart(true)
      const dateToday = dateFnsFormat(new Date(), "yyyy-MM-dd")

      const ReturnGet = await getRequest(
        `/reports/getbytickettype?&CompanyId=${selectedCompany.id}&beginDate=${dateToday}&endDate=${dateToday}`
      )

      if (ReturnGet.success) {
        ChartTicketbyCompany(ReturnGet.data)
      }
      setLoadingChart(false)
    }
  }

  const handleGetUsersON = async (text = "") => {
    // if (!selectedCompany.id) return;

    //BUSCA USUÁRIOS LOGADOS NO SOCKET
    setLoading(true)

    const response = await getRequest(
      `/dashboards/userson?CompanyId=${selectedCompany.id}&text=${text}`
    )

    if (response.success) {
      setListUsers(response.data)
    }
    setLoading(false)
  }

  const handleSearch = (value) => {
    if (value === "" || value.length > 2) {
      handleGetUsersON(value)
    }
  }

  const ChartbyCompany = (items) => {
    var lookup = {}
    var companies = []
    var kpis = []
    var name

    for (var item, i = 0; (item = items[i++]); ) {
      name = item.nickName

      if (!(name in lookup)) {
        lookup[name] = 1
        companies.push(name)
      }
    }

    for (item, i = 0; (item = items[i++]); ) {
      name = item.kpi

      if (!(name in lookup)) {
        lookup[name] = 1
        kpis.push(name)
      }
    }

    var values = []

    let colors = []

    kpis.forEach((kpi) => {
      var channelBar = items.filter((element) => element.kpi === kpi)
      channelBar.forEach((channel) => {
        values.push(channel.quantity)
        const color = colorsBarCompany.filter(
          (element) => element.description === kpi
        )
        colors.push(color[0].color)
      })
    })

    setData({
      labels: kpis,
      datasets: [
        {
          backgroundColor: colors,
          borderColor: "#FFFFFF",
          borderWidth: 1,
          data: values,
        },
      ],
    })
  }

  const ChartTicketbyCompany = (items) => {
    var lookup = {}
    var companies = []
    var kpis = []
    var name

    for (var item, i = 0; (item = items[i++]); ) {
      name = item.nickName

      if (!(name in lookup)) {
        lookup[name] = 1
        companies.push(name)
      }
    }

    for (item, i = 0; (item = items[i++]); ) {
      name = item.kpi

      if (!(name in lookup)) {
        lookup[name] = 1
        kpis.push(name)
      }
    }

    var values = []

    kpis.forEach((kpi) => {
      var channelBar = items.filter((element) => element.kpi === kpi)
      channelBar.forEach((channel) => {
        values.push(channel.quantity)
      })
    })

    setDataChartBytTicket({
      labels: kpis,
      datasets: [
        {
          backgroundColor: colorsBar,
          borderColor: "#FFFFFF",
          borderWidth: 1,
          data: values,
        },
      ],
    })
  }

  useEffect(() => {
    if (
      user?.UserTypeId !== 4 &&
      user?.UserTypeId !== 10 &&
      user?.UserTypeId !== 14 &&
      user?.UserTypeId !== 15
    ) {
      loadAverageServiceTime()
      loadCompanyTickets()
      loadMaximumWaitingTime()
      loadSelectedCompany()
      loadWaitingTime()
      loadChartByCompany()
      loadTicketNoAgent()
      loadMaximumServiceTime()
      loadChartTicketByCompany()
      toggleHelperId(5)
      loadSLAExpiredDated()
      loadSLAExpiredOpen()
    }
  }, [])

  useEffect(() => {
    if (
      user?.UserTypeId !== 4 &&
      user?.UserTypeId !== 10 &&
      user?.UserTypeId !== 14 &&
      user?.UserTypeId !== 15
    ) {
      handleGetUsersON()
    }
  }, [update])

  return (
    <div
      className="col-12"
      style={{ height: "100%", width: "100%", overflow: "auto" }}
    >
      {user?.UserTypeId !== 4 &&
      user?.UserTypeId !== 10 &&
      user?.UserTypeId !== 14 &&
      user?.UserTypeId !== 15 ? (
        <div className="row" style={{ height: "100%", width: "100%" }}>
          <div className="col-2">
            <div
              className="card md-1"
              style={{ height: "100%", overflow: "auto" }}
            >
              <div className="card-body" style={{ maxHeight: "60vh" }}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <h4 className="header-title">
                      {translate("loggedOperators")}
                    </h4>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="app-search" style={{ width: "100%" }}>
                        <form>
                          <div className="form-group position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Procurar"
                              onChange={(value) =>
                                handleSearch(value.target.value)
                              }
                            />
                            <span className="mdi mdi-magnify search-icon"></span>
                          </div>
                        </form>
                      </div>
                      <button
                        className="btn-update-list-users ml-2"
                        disabled={loading}
                        onClick={() => setUpdate(update + 1)}
                      >
                        <i className="mdi mdi-account-convert widget-icon bg-success-lighten text-success"></i>
                      </button>
                    </div>
                    <ShowOnlyOnlineUsersSelector
                      showOnlyOnlineUsers={showOnlyOnlineUsers}
                      onChange={(e) => {
                        setShowOnlyOnlineUsers(e.value)
                      }}
                    />
                  </div>
                </div>
                {!loading ? (
                  listUsers
                    .filter((user) =>
                      showOnlyOnlineUsers ? user.online : true
                    )
                    .map((data, index) => (
                      <div
                        className="media mt-2"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 20,
                        }}
                        key={index}
                      >
                        <div style={{ display: "flex", position: "relative" }}>
                          <ImageLoader
                            className={
                              data.online && data.isPaused
                                ? "mr-2 rounded-circle low-brightness"
                                : "mr-2 rounded-circle"
                            }
                            imgUrl={data.photo}
                            resourceType="avatar"
                            height="40"
                            width="40"
                            alt="avatar"
                            whosCalling="Home 509"
                          />
                          {data.online && data.isPaused ? (
                            <div className="pause-icon">
                              <i className="fas fa-pause"></i>
                            </div>
                          ) : (
                            <></>
                          )}

                          <OnlineOfflineUserBadge
                            isPaused={data.isPaused}
                            online={data.online !== 0}
                            position={{
                              left: "-5px",
                            }}
                          />

                          <div className="media-body">
                            <h5 className="mt-0 mb-1">{data.name}</h5>
                            {data.beginDate && (
                              <span className="font-13">
                                <b>Login :</b>
                                {format(data.beginDate, "HH:mm:ss")}
                              </span>
                            )}
                          </div>
                        </div>
                        <Tooltip arrow title={translate("calls")}>
                          <span
                            style={{ color: "black", cursor: "pointer" }}
                            className="text-count-list-tickets-chat"
                          >
                            {data.quantity}
                          </span>
                        </Tooltip>
                      </div>
                    ))
                ) : (
                  <div className="area-loading">
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col md-1 sd-1 lg-6" style={{ height: "70vh" }}>
            <div className="row">
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi  mdi mdi-file-document widget-icon bg-danger text-warning"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("expiredSLA")}
                    </h5>

                    <h3 className="mt-2 mb-1">{slaExpiredOpen}</h3>
                    <span className="text-danger mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-danger align-middle mr-1"></small>
                      {translate("inOpen")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi  mdi mdi-file-document widget-icon bg-danger text-warning"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("expiredSLA")}
                    </h5>

                    <h3 className="mt-2 mb-1">{slaExpiredDated}</h3>
                    <span className="text-danger mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-danger align-middle mr-1"></small>
                      {translate("concluded")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi  mdi mdi-file-document widget-icon bg-warning text-danger"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("tickets")}
                    </h5>

                    <h3 className="mt-2 mb-1">{ticketNoAgent}</h3>
                    <span className="text-secondary mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-secondary align-middle mr-1"></small>
                      {translate("inQueue")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body" style={{ width: "100%" }}>
                    <div className="float-right">
                      <i
                        className="mdi mdi mdi mdi-progress-clock widget-icon bg-primary-lighten text-primary"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("tickets")}
                    </h5>
                    <h3 className="mt-2 mb-1">{ticketInProgress}</h3>
                    <span className="text-secondary mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-secondary align-middle mr-1"></small>
                      {translate("inAttendance")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi mdi mdi-progress-clock widget-icon bg-primary-lighten text-primary"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("awaiting")}
                    </h5>
                    <h3 className="mt-2 mb-1">
                      {waitingtime ? waitingtime : "-"}
                    </h3>
                    <span className="text-secondary mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-secondary align-middle mr-1"></small>
                      {translate("averageToday")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi mdi mdi-progress-clock widget-icon bg-primary-lighten text-primary"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("awaiting")}
                    </h5>
                    <h3 className="mt-2 mb-1">
                      {maximumwaitingtime ? maximumwaitingtime : "-"}
                    </h3>
                    <span className="text-danger mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-danger align-middle mr-1"></small>
                      {translate("maximunToday")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi mdi mdi-progress-clock widget-icon bg-primary-lighten text-primary"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("attendance")}
                    </h5>
                    <h3 className="mt-2 mb-1">
                      {averageservicetime ? averageservicetime : "-"}
                    </h3>
                    <span className="text-secondary mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-secondary align-middle mr-1"></small>
                      {translate("averageToday")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-2">
                <div className="card widget-flat">
                  <div className="card-body">
                    <div className="float-right">
                      <i
                        className="mdi mdi mdi mdi-progress-clock widget-icon bg-primary-lighten text-primary"
                        style={{
                          display: "flex",
                          height: "2.2vw",
                          width: "2.2vw",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></i>
                    </div>
                    <h5 className="text-muted font-weight-normal mt-0">
                      {translate("attendance")}
                    </h5>
                    <h3 className="mt-2 mb-1">
                      {maximumservicetime ? maximumservicetime : "-"}
                    </h3>
                    <span className="text-danger mr-2">
                      <small className="mdi mdi-checkbox-blank-circle text-danger align-middle mr-1"></small>
                      {translate("maximunToday")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col md-1 sd-1 lg-3">
                <div className="card widget-flat">
                  <div className="card-body">
                    <h5 className="text-muted font-weight-normal mt-0 mb-2">
                      {translate("ticketsOppenedTodayByChannel")}
                    </h5>
                    {!loadingChart ? (
                      <div>
                        {data?.labels?.length > 0 && (
                          <Doughnut
                            data={data}
                            width={null}
                            height={null}
                            options={options2}
                          />
                        )}
                      </div>
                    ) : (
                      <CircularProgress />
                    )}
                  </div>
                </div>
              </div>
              <div className="col md-1 sd-1 lg-3">
                <div className="card widget-flat">
                  <div className="card-body">
                    <h5 className="text-muted font-weight-normal mt-0 mb-2">
                      {translate("ticketsOppenedTodayByType")}
                    </h5>
                    {!loadingChart ? (
                      <div>
                        {dataChartByTicket?.labels?.length > 0 && (
                          <Doughnut
                            data={dataChartByTicket}
                            width={null}
                            height={null}
                            options={options2}
                          />
                        )}
                      </div>
                    ) : (
                      <CircularProgress />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <AttendentDashboard />
      )}
    </div>
  )
}
